var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kbd',{staticClass:"hotkey p-0.5 min-w-[1rem] uppercase",class:_vm.customClass},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }